module.exports = __webpack_public_path__ + "static/1-ac51d058d5dc76749f6b7ec9c756ff9d.png";